import { render } from "./maskTips.vue?vue&type=template&id=5d4c060c&scoped=true"
import script from "./maskTips.vue?vue&type=script&lang=js"
export * from "./maskTips.vue?vue&type=script&lang=js"

import "./maskTips.vue?vue&type=style&index=0&id=5d4c060c&scoped=true&lang=css"

import exportComponent from "D:\\site\\online-photo\\watermark-remover-spa\\tipard.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4c060c"]])

export default __exports__